import { useTranslation } from 'react-i18next'

import { Form } from 'app/common/presentation'
import { useUser } from 'app/user/application'

import { PageHeader } from '../components'
import styles from './General.module.scss'

const General = () => {
  const { t } = useTranslation('settings')
  const { workspace } = useUser()

  const name = workspace?.name ?? ''

  return (
    <>
      <PageHeader
        title={t('pages.general.title')}
        description={t('pages.general.description', { workspace: name })}
      />
      <div className={styles.workspace}>
        <Form.InputFormRow
          description={t('workspace.name.description')}
          title={t('workspace.name.title')}
          value={name}
        />
      </div>
    </>
  )
}

export default General
